import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, Modal } from 'antd';
import moment from 'moment';
import { inject, observer } from "mobx-react";
import { dataDefault } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import TableText from "../../TableText";
import { getJson, numConvert } from "../../../../method";
import FileSaver from "file-saver";
import Table2 from "./4-1-2"
import Table3 from "../4-2"
import Table4_1_3 from "./4-1-3"
import Note from "./note"
import setOption from "./setOption";
import compute from "./compute";
import Table4 from "./4-1-4";
import Table5 from "./4-1-5";
import "./index.scss";

const confirm = Modal.confirm;
const { MonthPicker } = DatePicker;
const totalIndex = [3, 4, 5, 9, 10, 11, , 15, 16, 17, 21, 22, 23, 27, 28, 29, 33, 34, 35];


@inject('store')
@observer
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').isBefore(moment('2023-12-31')) ? moment().subtract(1, 'month').format('YYYY-MM') : '2023-12',
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            data1_1: [],
            dataLast: {}
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = (data, isUpdate) => {
        data = compute(data, this.state.date);
        setOption({ data, dataLast: this.state.dataLast, date: this.state.date })
        this.setState({ data, loading: false, });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        this.setState({ loading: true });
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);
        const month = moment(date).format('M');
        const year = moment(date).format('YYYY');

        fetch(`/_4_1_info?year=${year}&month=${month}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.data && x.data.data.length > 0) {
                data = x.data.data.sort((a, b) => {
                    return a.sort - b.sort
                });
            }

            // 自动填充预算数据，从BP8.2获取
            if (x.data.b8_2 && x.data.b8_2.length > 0 && month == 1 && year >= 2020) {
                const b8_2 = x.data.b8_2.sort((a, b) => {
                    return a.sort - b.sort
                });

                data = data.map((item, i) => {
                    if (i % 3 == 0 && i < 36) {
                        const num = Math.ceil((i + 1) / 3);
                        const index = ((num - 1) * 4) + 3;
                        let d = b8_2[index] || {};
                        delete d.id;
                        return { ...item, ...d, sort: item.sort };
                    }
                    return item;
                });
            }

            // 自动填充上个月的数据,一月份不适用此方法
            if (x.data.lastMonthData && x.data.lastMonthData.length > 0 && month > 1) {
                const lastMonthData = x.data.lastMonthData.sort((a, b) => {
                    return a.sort - b.sort
                });

                data = lastMonthData.map((item, i) => {
                    delete item.id;
                    if (data[i].id) {
                        item.id = data[i].id;
                    }
                    // 预测数据填写依次自动填充
                    if ((!x.data.data || x.data.data.length <= 0) && ((Math.ceil((i + 1) / 3) > month) && i % 3 == 1)) {
                        return item;
                    }
                    // 本月至12月份的数据，使用当月
                    if ((Math.ceil((i + 1) / 3) > (month - 1)) && i % 3 == 1) {
                        return { ...data[i] };
                    }
                    return item;
                });
            }
            if (x.data.lastYearData && x.data.lastYearData.length > 0) {
                const allListName = ["best_rn", "best_arr", "best_rev", "corporate_rn", "corporate_arr", "corporate_rev", "government_rn", "government_arr", "government_rev", "packges_rn", "packges_arr", "packges_rev", "wholesale_rn", "wholesale_arr", "wholesale_rev", "commerce_rn", "commerce_arr", "commerce_rev", "discounts_rn", "discounts_arr", "discounts_rev", "total_rn", "total_arr", "total_rev", "business_rn", "business_arr", "business_rev", "leisure_rn", "leisure_arr", "leisure_rev", "group_total_rn", "group_total_arr", "group_total_rev", "contracts_rn", "contracts_arr", "contracts_rev", "others_rev", "grand_rn", "grand_arr", "grand_rev", "grand_occ", "grand_revpar", "grand_rms"];
                const lastYearData = x.data.lastYearData.sort((a, b) => {
                    return a.sort - b.sort
                });
                // 去年的实际数据填充到Actual Last Year
                data = data.map((item, i) => {
                    if (i <= 43 && i % 3 == 2) {
                        allListName.forEach(name => {
                            item[name] = getJson([i - 1, name], lastYearData);
                        });
                        return item
                    } else {
                        return item
                    }
                });
            }
            this.setState({ data1_1: x.data.data1_1 || [], dataLast: x.data.lastYearData || [] });
            this.computeNum(data, true);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        const that = this;

        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }

        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map((x, i) => ({ ...x, year, month, sort: i }));
        // if (month == 1) {
        //     const allListName = ["best_rn", "best_arr", "best_rev", "corporate_rn", "corporate_arr", "corporate_rev", "government_rn", "government_arr", "government_rev", "packges_rn", "packges_arr", "packges_rev", "wholesale_rn", "wholesale_arr", "wholesale_rev", "commerce_rn", "commerce_arr", "commerce_rev", "discounts_rn", "discounts_arr", "discounts_rev", "total_rn", "total_arr", "total_rev", "business_rn", "business_arr", "business_rev", "leisure_rn", "leisure_arr", "leisure_rev", "group_total_rn", "group_total_arr", "group_total_rev", "contracts_rn", "contracts_arr", "contracts_rev", "others_rev", "grand_rn", "grand_arr", "grand_rev", "grand_occ", "grand_revpar", "grand_rms"];
        //     data.forEach((item, i) => {
        //         if (i <= 43 && (i % 3 == 1) && i >= 3) {
        //             allListName.forEach(name => {
        //                 data[i][name] = data[i - 1][name];
        //             })
        //         }
        //     });
        //     this.setState({ data });
        // }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify({ data, year, month, isCover: 0 }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_4_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            } else if (x.status == 3) {
                message.error(x.msg);
                // 数据存在，选择是否进行强制覆盖 isCover=1进行强制覆盖
                confirm({
                    title: '数据已被保存是否进行强制覆盖?',
                    content: '强制覆盖之后，已保存的信息将被删除，请查看是否有其他同事在操作当前表格，或者及时联系管理员！',
                    onOk() {
                        that.setState({ loadingSave: true });
                        let dFrom = new FormData();

                        dFrom.append('data', JSON.stringify({ data, year, month, isCover: 1 }));
                        headres.body = dFrom;
                        fetch('/add_4_1', headres).then(x => x.json()).then(x => {
                            let timer = setTimeout(() => { that.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
                            if (x.status == 1) {
                                message.success(x.msg);
                                if (!data[0].id) {
                                    that.getDateData(that.state.date);
                                }
                                return
                            }
                            message.error(x.msg);
                        }).catch(err => {
                            let timer = setTimeout(() => { that.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
                            console.error(err);
                            message.error('保存失败' + JSON.stringify(err));
                        })
                    },
                    onCancel() { },
                });
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_1_1', 1.5, '4.11', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });
    }

    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} Property Room Budget By Segmentation`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }

    render() {
        const { data1_1, data, date, print } = this.state;
        const year = moment(date).format('YYYY');
        const month = moment(date).format('M');
        const width = document.body.offsetWidth - 6450 > 350 ? document.body.offsetWidth - 6450 : 350;

        const columns = [{
            title: 'MONTH',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: print ? false : "left",
            width: width * 0.5,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'textcenter',
                    name: "name",
                    onChange: this.onChange,
                    totalIndex
                };

                if (index < 42 && (index % 3 == 0)) {
                    return {
                        props: {
                            rowSpan: 3
                        },
                        children: <TableText data={props} />
                    }
                }

                if (index === 42 || index === 45) {
                    return {
                        props: {
                            rowSpan: 2
                        },
                        children: <TableText
                            data={{ ...props, text: index == 42 ? `% to Budget ${year}` : text }}
                        />
                    }
                }

                if (index === 44) {
                    return <TableText data={props} />
                }

                return {
                    props: {
                        rowSpan: 0
                    },
                }

            }
        }, {
            title: '',
            dataIndex: 'month_status',
            key: 'month_status',
            align: "center",
            fixed: print ? false : "left",
            width: width * 0.5,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange: this.onChange,
                    totalIndex
                };
                if (index < 42 && index != 40) {
                    let str = '';
                    if (index % 3 == 0) str = `Budget ${year}`;
                    if (index % 3 == 1) str = `${Math.ceil((index + 1) / 3) <= month ? 'Actual' : "Forecast"} ${year}`;
                    if (index % 3 == 2) str = `Actual Last Year`;
                    // if (index == 34) {
                    //     if (index % 3 == 1) str = `${Math.ceil((index + 1) / 3) == month ? `Actual ${year}` : `Forecast ${year}`} `;
                    // }
                    if (index == 37) str = `Actual ${year}`;
                    return <TableText data={{ ...props, text: str }} />
                }
                let t = '';
                if (index == 46) t = `Act/Fcst ${year}`;
                if (index == 45) t = `Budget ${year}`;
                if (index == 44) t = `YTD Actual ${year}`;
                if (index == 43) t = `Y/E Fcast ${year}`;
                if (index == 42) t = `YTD Actual ${year}`;
                if (index == 40) t = `Act/Fcst ${year}`;
                return (
                    <TableText
                        data={{
                            ...props,
                            text: t
                        }}
                    />
                )
            }
        }, {
            title: `BEST RATES`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'best_rn',
                key: 'best_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['BEST RATES', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "best_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'best_arr',
                key: 'best_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['BEST RATES', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "best_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'best_rev',
                key: 'best_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['BEST RATES', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "best_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `CORPORATE NEGOTIATED`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'corporate_rn',
                key: 'corporate_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['CORPORATE NEGOTIATED', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "corporate_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'corporate_arr',
                key: 'corporate_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['CORPORATE NEGOTIATED', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "corporate_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'corporate_rev',
                key: 'corporate_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['CORPORATE NEGOTIATED', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "corporate_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `GOVERNMENT / EMBASSY`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'government_rn',
                key: 'government_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GOVERNMENT / EMBASSY', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "government_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'government_arr',
                key: 'government_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['GOVERNMENT / EMBASSY', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "government_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'government_rev',
                key: 'government_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GOVERNMENT / EMBASSY', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "government_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `PACKAGES`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'packges_rn',
                key: 'packges_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['PACKAGES', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "packges_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'packges_arr',
                key: 'packges_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['PACKAGES', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "packges_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'packges_rev',
                key: 'packges_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['PACKAGES', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "packges_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `WHOLESALE`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'wholesale_rn',
                key: 'wholesale_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['WHOLESALE', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wholesale_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'wholesale_arr',
                key: 'wholesale_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['WHOLESALE', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wholesale_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'wholesale_rev',
                key: 'wholesale_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['WHOLESALE', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "wholesale_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `E-COMMERCE`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'commerce_rn',
                key: 'commerce_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['E-COMMERCE', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "commerce_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'commerce_arr',
                key: 'commerce_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['E-COMMERCE', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "commerce_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'commerce_rev',
                key: 'commerce_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['E-COMMERCE', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "commerce_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `DISCOUNTS`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'discounts_rn',
                key: 'discounts_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['DISCOUNTS', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "discounts_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'discounts_arr',
                key: 'discounts_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['DISCOUNTS', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "discounts_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'discounts_rev',
                key: 'discounts_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['DISCOUNTS', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "discounts_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `TOTAL TRANSIENT`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'total_rn',
                key: 'total_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['TOTAL TRANSIENT', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "total_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'total_arr',
                key: 'total_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['TOTAL TRANSIENT', `A.R.R`, record.month_status_name];
                    let props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "total_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };
                    if (index >= 45) props.type = '';
                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'total_rev',
                key: 'total_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['TOTAL TRANSIENT', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "total_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        }, {
            title: `GROUP BUSINESS`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'business_rn',
                key: 'business_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GROUP BUSINESS', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "business_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'business_arr',
                key: 'business_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['GROUP BUSINESS', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "business_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'business_rev',
                key: 'business_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GROUP BUSINESS', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "business_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `GROUP LEISURE`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'leisure_rn',
                key: 'leisure_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GROUP LEISURE', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "leisure_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'leisure_arr',
                key: 'leisure_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['GROUP LEISURE', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "leisure_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) props.type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'leisure_rev',
                key: 'leisure_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GROUP LEISURE', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "leisure_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `TOTAL GROUPS`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'group_total_rn',
                key: 'group_total_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['TOTAL GROUPS', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "group_total_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'group_total_arr',
                key: 'group_total_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['TOTAL GROUPS', `A.R.R`, record.month_status_name];
                    let props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "group_total_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };
                    if (index >= 45) props.type = '';
                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'group_total_rev',
                key: 'group_total_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['TOTAL GROUPS', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "group_total_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        }, {
            title: `CONTRACTS`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'contracts_rn',
                key: 'contracts_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['CONTRACTS', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "contracts_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'contracts_arr',
                key: 'contracts_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['CONTRACTS', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "contracts_arr",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';

                    if (index >= 42) type = 'percent';
                    if (index >= 45) type = '';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'contracts_rev',
                key: 'contracts_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['CONTRACTS', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "contracts_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    // 每个月份的第二行，只有月份等于填写月份或者等于填写月份上个月时开放填写(修改为当前以及之后的月份全部可填写)
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `OTHERS`,
            width: 450,
            children: [{
                title: `Revenue`,
                dataIndex: 'others_rev',
                key: 'others_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['OTHERS', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "others_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    if (index >= 42) type = 'percent';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }, {
            title: `GRAND TOTAL`,
            width: 450,
            children: [{
                title: `R/Nts`,
                dataIndex: 'grand_rn',
                key: 'grand_rn',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GRAND TOTAL', `R/Nts`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "grand_rn",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `A.R.R`,
                dataIndex: 'grand_arr',
                key: 'grand_arr',
                width: 150,
                align: "center",
                render: (text, record, index) => {
                    const title = ['GRAND TOTAL', `A.R.R`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index > 44 ? '-' : index >= 42 ? "percent"
                            : 'number',
                        name: "grand_arr",
                        yellowText: index === 40 && numConvert(text) != numConvert(getJson([3, 'whole_actual'], data1_1)) && "与ES1.1数据不一致，请检查！",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `Revenue`,
                dataIndex: 'grand_rev',
                key: 'grand_rev',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GRAND TOTAL', `Revenue`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index >= 42 ? "percent" : 'number',
                        name: "grand_rev",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `Occ %`,
                dataIndex: 'grand_occ',
                key: 'grand_occ',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GRAND TOTAL', `Occ %`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index > 44 ? '-' : "percent",
                        name: "grand_occ",
                        yellowText: index === 40 && numConvert(text) != numConvert(getJson([2, 'whole_actual'], data1_1)) && "与ES1.1数据不一致，请检查！",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `RevPAR`,
                dataIndex: 'grand_revpar',
                key: 'grand_revpar',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GRAND TOTAL', `RevPAR`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index > 44 ? '-' : index >= 42 ? "percent" : 'number',
                        name: "grand_revpar",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                title: `Available Rms`,
                dataIndex: 'grand_rms',
                key: 'grand_rms',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    const title = ['GRAND TOTAL', `Available Rms`, record.month_status_name];
                    const props = {
                        text,
                        index,
                        type: index > 41 ? '-' : 'number',
                        name: "grand_rms",
                        onChange: this.onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_1_rev"
                        }
                    };

                    let type = index > 41 ? '-' : 'number';
                    // 取消第一行预算的填写
                    // if (index < 36 && index % 3 == 0 && month == 1 && !print) type = 'inputNumber';
                    if (!print && index < 36 && index % 3 == 1 && (Math.ceil((index + 1) / 3) > (month - 1))) type = 'inputNumber';
                    return (
                        <TableText data={{ ...props, type }} />
                    )
                }
            }]
        }];

        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <div className="table7_1_1 tableHeight">
                        <Row className="title" id="table4_1_1" style={{ width: print ? 6850 : 'auto' }}>
                            <Row>4.1.1 Monthly Market Segmentation report 月度市场细分报表</Row>
                            <Row style={{ fontSize: 14, margin: "10px 0" }}>
                                若显示黄色预警，请核对与ES1.1的整年预测中可售房量，已售房量，收益总额这三组数据是否一致。
                            </Row>
                            <Row style={{ fontSize: 14, margin: "10px 0", color: "red" }}>
                                此表从2024年起停止使用
                            </Row>
                            <Row className="table-month">
                                <MonthPicker
                                    placeholder="请选择年月"
                                    monthCellContentRender={(date, local) => {
                                        return moment(date).format('M月')
                                    }}
                                    disabledDate={v => {
                                        if (moment(v).isBefore(moment('2023-12-31'))) return false;
                                        return true;
                                    }}
                                    defaultValue={moment(this.state.date, "YYYY-MM")}
                                    format="YYYY-MM"
                                    onChange={(date, str) => {
                                        this.setState({
                                            date: str,
                                            data: [],
                                        });
                                        this.getDateData(str)
                                    }}
                                />

                            </Row>
                            <Table
                                columns={columns}
                                dataSource={data}
                                size="middle"
                                id="table"
                                bordered
                                pagination={false}
                                rowClassName="protruding"
                                className="content"
                                style={{ width: print ? 6800 : 'auto' }}
                                scroll={print ? {} : { x: 6800, y: 500 }}
                                rowKey={(record, index) => index}
                            />
                            <div className="chart-4-1">
                                <div id="chartOcc"></div>
                                <div id="chartAdr"></div>
                                <div id="chartRevpar"></div>
                                <div id="chartRev"></div>
                            </div>
                        </Row>
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.downloadExcel();
                                    });
                                }}
                                loading={print}
                            >导出Excel</Button>
                            <Auth loading={this.state.loading} auth="edit_4_1">
                                <Button
                                    type="primary"
                                    style={{ margin: '0 10px' }}
                                    onClick={this.downloadSG}
                                    loading={print}
                                >加入pdf</Button>
                                <Button
                                    type="primary"
                                    onClick={this.onSave}
                                    loading={this.state.loadingSave}
                                >保存</Button>
                            </Auth>
                        </Row>
                    </div>
                </Spin >
                <Table2 key={2} />
                <Table3 />
                <Table4_1_3 />
                <Table4 />
                <Table5 />
                <Note />
            </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/index.js